import { render, staticRenderFns } from "./Ringkasan.vue?vue&type=template&id=a3495d8e&scoped=true&"
import script from "./Ringkasan.vue?vue&type=script&lang=js&"
export * from "./Ringkasan.vue?vue&type=script&lang=js&"
import style0 from "./Ringkasan.vue?vue&type=style&index=0&id=a3495d8e&scoped=true&lang=css&"
import style1 from "./Ringkasan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3495d8e",
  null
  
)

export default component.exports